window.app_models.contact = {
    "id":null,
    "type_id":null,
    "other_type_info": null,
    "name":"",
    "email":"",
    "phone":null,
    "cell":null,
    "fax":null,
    "emergency":null,
    "text":null,
    "personal_identifier":null,
    "personal_guidelines":null,
    "invoicing_preferences":null,
    "sales_rep_id": null,
    "license_number": null,
    "address":window.app_models.address,
    "company":window.app_models.company,
    approved_at: null,
    company_contacts: [window.app_models.company_contact],
    "companies": [
        window.app_models.company
    ]
};



// WEBPACK FOOTER //
// ./resources/assets/js/models/contact.js